import type { Product } from "@decocms/apps-commerce/types";
import TabCategorieShelf from "~/components/product/TabCategorieShelf";
import { stripInlineStyles } from "~/utils/richText";

export interface Props {
  title?: string;
  /** @format rich-text */

  /**
   * @title Subtítulo
   * @description Subtítulo opcional abaixo do título principal
   * @format rich-text
   */
  subtitle?: string;

  products?: Product[] | null;

  /**
   * @title Ativar cor de Black Friday?
   * @description Ativa as cores de Black Friday e remove a de Natal
   */
  colorDefault?: boolean;

  /**
   * @title URL para "Ver Todos"
   * @description Link para página com todos os produtos
   */
  seeAllUrl?: string;

  /**
   * @title Texto do "Ver Todos"
   * @description Texto personalizado para o link "ver todos"
   * @default "ver todos"
   */
  seeAllText?: string;
}

function SimpleShelf({
  products,
  title,
  subtitle,
  colorDefault: _colorDefault,
  seeAllUrl,
  seeAllText = "ver todos",
}: Props) {
  if (!products || !Array.isArray(products) || products.length === 0) {
    return null;
  }

  return (
    <section className="mt-6 xl:mt-8">
      <div className="flex flex-col gap-0 items-center justify-center max-w-[92vw] 2xl:max-w-[96vw] m-auto">
        {title && (
          <div
            className="flex w-full m-0 text-[22px] lg:text-2xl text-[#1A1A1A] font-medium title-shelf-categories"
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        )}

        {subtitle && (
          <div
            className="flex w-full m-0 text-[11px] font-normal lg:text-[13px] text-[#757575] mt-2 subtitle-shelf"
            dangerouslySetInnerHTML={{
              __html: stripInlineStyles(subtitle),
            }}
          />
        )}

        {seeAllUrl && (
          <a
            href={seeAllUrl}
            className=" text-xs lg:text-sm see-all text-[#000000] hover:text-[#7A7A7A] underline  font-normal hover:underline flex w-full uppercase mt-0"
          >
            {seeAllText}
          </a>
        )}

        <div className="mt-2 max-w-[91vw] 2xl:max-w-[96vw]">
          <div className="flex flex-col gap-0 items-center max-w-max m-auto">
            <div className="mt-4 m-auto">
              <TabCategorieShelf
                products={products}
                automatic={true}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SimpleShelf;
